import { inputCall } from '../../control'

export const getBlockDictKeyDataControlDescriptors = (state: any, schema: any, name: string) => [
    inputCall({
        state,
        name,
        schema: schema.children.key,
        type: schema.children.key.type,
        isLabelHidden: true,
        isFeedbackFixed: true,
        className: 'app-dictionary-row-input mr-1',
    }),
]

export const getBlockDictValueDataControlDescriptors = (state: any, schema: any) => [
    inputCall({
        name: 'value',
        state: state,
        schema: schema.value,
        type: schema.value.type,
        isLabelHidden: true,
        isFeedbackFixed: true,
        className: 'app-dictionary-row-input',
    }),
]

export function isAllNumeric(keys: string[]) {
    return keys?.every(key => Number.isFinite(parseFloat(key)))
}